"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwipeDrawer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SwipeDrawer = require("./styles/SwipeDrawer");
var _reactDom = _interopRequireDefault(require("react-dom"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SwipeDrawer = ({
  text,
  design,
  buttonClass,
  cardClass,
  children,
  height = '60vh',
  icon,
  dataCy = 'swipeDrawer',
  yAxisCardSwipePercentage = 100
}) => {
  const [touchStart, setTouchStart] = (0, _react.useState)(null);
  const [touchEnd, setTouchEnd] = (0, _react.useState)(null);
  const [isDrawerOpen, setIsDrawerOpen] = (0, _react.useState)(false);
  const minSwipeDistance = 50;
  const overlayRef = (0, _react.useRef)(null);
  const cardRef = (0, _react.useRef)(null);
  const onTouchStart = e => {
    setTouchEnd(null);
    const clientY = e.targetTouches[0].clientY;
    if (yAxisCardSwipePercentage === 100) {
      setTouchStart(clientY);
      return;
    }
    const yAxisEventOffset = yAxisCardSwipePercentage * overlayRef.current.clientHeight / 100;
    const calcOffset = yAxisEventOffset + (overlayRef.current.clientHeight - cardRef.current.clientHeight);
    clientY < calcOffset && setTouchStart(clientY);
  };
  const onTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientY);
  };
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isDownSwipe = distance < -minSwipeDistance;
    if (isDownSwipe && isDrawerOpen) {
      setTouchStart(null);
      setTouchEnd(null);
      setIsDrawerOpen(false);
    }
  };
  (0, _react.useEffect)(() => {
    document.body.style.overflow = isDrawerOpen ? 'hidden' : 'unset';
  }, [isDrawerOpen]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": dataCy,
    "data-cy": dataCy
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-testid": "swipeDrawerButton",
    className: buttonClass,
    onClick: () => {
      !isDrawerOpen && setIsDrawerOpen(true);
    },
    text: text,
    design: design,
    icon: icon
  }), /*#__PURE__*/_reactDom.default.createPortal(/*#__PURE__*/_react.default.createElement(_SwipeDrawer.StyledDrawerOverlay, {
    height: height,
    ref: overlayRef,
    "data-testid": "drawerContainer",
    className: (0, _classnames.default)('drawer-container', {
      visible: isDrawerOpen
    }, {
      'not-visible': !isDrawerOpen
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: cardRef,
    id: "swipeDrawerCard",
    "data-testid": "swipeDrawerCard",
    className: (0, _classnames.default)('card-swipe-drawer-container', cardClass),
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd
  }, /*#__PURE__*/_react.default.createElement(_SwipeDrawer.ChildrenContainer, {
    height: height
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "drawer-line"
  }), isDrawerOpen && children))), document.body));
};
exports.SwipeDrawer = SwipeDrawer;
SwipeDrawer.propTypes = {
  text: _propTypes.default.string,
  design: _propTypes.default.string,
  buttonClass: _propTypes.default.string,
  cardClass: _propTypes.default.string,
  children: _propTypes.default.object,
  height: _propTypes.default.string,
  icon: _propTypes.default.object,
  dataCy: _propTypes.default.string,
  yAxisCardSwipePercentage: _propTypes.default.number
};